import { useEffect, useRef } from 'react';

function useKeyDown(
  keyOrKeysArr,
  callback,
  { targetRef = null, enabled = true } = {}
) {
  const callbackFnRef = useRef(callback);
  const elTargetRef = useRef(null);
  const enabledPrevValue = useRef(enabled);

  useEffect(() => {
    callbackFnRef.current = callback;

    elTargetRef.current = targetRef?.current ? targetRef.current : document;
  }, [callback, targetRef]);

  useEffect(() => {
    const callCallbackFn = (event) => {
      event.preventDefault();
      callbackFnRef.current();
    };

    const handleKeyDown = (event) => {
      const { code } = event;

      if (Array.isArray(keyOrKeysArr)) {
        const keyPressed = keyOrKeysArr.find((key) => key === code);

        if (keyPressed) {
          callCallbackFn(event);
        }
      }

      if (typeof keyOrKeysArr === 'string') {
        if (keyOrKeysArr === code) {
          callCallbackFn(event);
        }
      }
    };

    if (!enabled && enabledPrevValue.current) {
      elTargetRef.current.removeEventListener('keydown', handleKeyDown);
    }

    if (enabled) {
      elTargetRef.current.addEventListener('keydown', handleKeyDown);
    }

    enabledPrevValue.current = enabled;

    return () => {
      elTargetRef.current.removeEventListener('keydown', handleKeyDown);
    };
  }, [keyOrKeysArr, enabled]);
}

export default useKeyDown;
